import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=32765c34&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../../less/scan.less?vue&type=style&index=0&id=32765c34&lang=less&scoped=true&"
import style1 from "../../../less/personalInfo.less?vue&type=style&index=1&id=32765c34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32765c34",
  null
  
)

export default component.exports